<div class="img">
    <img [src]="imageSrc"  width="100%" height="100%">
</div>

